export const isProduction = process.env.REACT_APP_ENV === 'production';
export const isDevelopment = process.env.REACT_APP_ENV === 'development';
export const isStaging = process.env.REACT_APP_ENV === 'stg';

export const ONE_LINK_BASE_URL = process.env.REACT_APP_ONE_LINK_BASE_URL;
export const WEB_BASE_URL = process.env.REACT_APP_BASE_URL;
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
